import {
  FIRE_ALARM_TEST_LOG_TYPE_SLUG,
  FIRE_DOOR_INSPECTION_LOG_TYPE_SLUG,
} from "@/lib/fire-alarm-tests";
import {
  EMERGENCY_LIGHTING_LOG_TYPE_SLUG,
  FRIDGE_TEMPERATURE_LOG_TYPE_SLUG,
  GARDEN_SUPERVISION_LOG_TYPE_SLUG,
  SLEEP_CHECK_LOG_TYPE_SLUG,
} from "@/lib/monitoring";

/**
 * Log types that get a row in the Workspace Logs tab and on /logs. A slug missing
 * here is silently hidden, not a build error.
 */
export const LOG_SESSION_SLUGS: readonly string[] = [
  SLEEP_CHECK_LOG_TYPE_SLUG,
  FRIDGE_TEMPERATURE_LOG_TYPE_SLUG,
  GARDEN_SUPERVISION_LOG_TYPE_SLUG,
  "hot-holding-temperature",
  EMERGENCY_LIGHTING_LOG_TYPE_SLUG,
  FIRE_ALARM_TEST_LOG_TYPE_SLUG,
  FIRE_DOOR_INSPECTION_LOG_TYPE_SLUG,
];

export function isLogSessionSlug(slug: string | null | undefined): boolean {
  return !!slug && LOG_SESSION_SLUGS.includes(slug);
}
